import HcSticky from 'hc-sticky'
import log from 'salvo-lite/log'
class Sticky {
    constructor (theme, elem) {
        this._elem = elem
        this._options = {
            top: 0,
            bottomEnd: 0,
            innerTop: 0,
            followScroll: true,
            desktopOnly: false,
            stickTo: elem.closest('.sticky-container') || elem.parentNode,
            ...JSON.parse(elem.dataset.sticky)
        }
        if (this._options.desktopOnly) {
            this._options.responsive = {
                1024: {
                    disable: true
                }
            }
        }
    }

    onInit () {
        let Sticky = new HcSticky(this._elem, this._options)
        log.debug(this.constructor.name, 'Constructed', Sticky)
    }
}
export default Sticky



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Sticky.js